import type {} from "@lit/react";
import { ContextMenuItem as ContextMenuItemElement, } from "@vaadin/context-menu/vaadin-context-menu-item.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { ContextMenuItemElement };
export type ContextMenuItemEventMap = Readonly<{}>;
const events = {} as ContextMenuItemEventMap;
export type ContextMenuItemProps = WebComponentProps<ContextMenuItemElement, ContextMenuItemEventMap>;
export const ContextMenuItem = createComponent({
    elementClass: ContextMenuItemElement,
    events,
    react: React,
    tagName: "vaadin-context-menu-item",
});
